import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { redirect_path } from '../config/config';
import { isLoggedIn } from '../config/token';
import LoginForm from '../components/Login/LoginForm';

const globalReset = `
  html, body, #root {
    margin: 0 !important;
    padding: 0 !important;
    height: 100%;
    overflow-x: hidden;
  }
`;

const Login = () => {
  const [successLogIn, setLoginSuccess] = useState(false);

  if (isLoggedIn() || successLogIn)
    return <Redirect to={redirect_path} />;

  return (
    <>
      <style>{globalReset}</style>
      <LoginForm setLoginSuccess={setLoginSuccess} />
    </>
  );
};

export default Login;